export default {
  201: 'El ciclo se creó con éxito',
  202: 'El ciclo se editó con éxito',
  404: 'No se encontró el ciclo',
  420: 'No se ha podido eliminar porque el ciclo tiene un grupo asignado',
  427: 'La clave ya se encuentra registrada',
  428: 'No se puede eliminar el ciclo porque está activo',
  447: 'El id no es válido',
};
